import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LMWebAppInitializerService
} from './lm-webapp-initializer.service';

@NgModule({
  imports: [ CommonModule ],
  declarations: [],
  providers: [
    provideAppInitializer(() => {
      const service = inject(LMWebAppInitializerService);
      return service.initialize();
    })
  ]
})
export class LMWebAppInitializerModule {}
